import { faArrowUpRightFromSquare, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { SearchRequestTypes } from '../../../components/muiLegacy/Tables/KeywordTable/ToolbarButtons/AddKeywords/AddBasicKeywords/logic/SearchModels';
import VoxelIconButton from '../../../components/voxel/Buttons/VoxelIconButton';
import VoxelDialog from '../../../components/voxel/Dialogs/VoxelDialog';
import VoxelDialogContent from '../../../components/voxel/Dialogs/VoxelDialogContent';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import { GoogleAdsRequestAnalysisGq } from '../../../graphql/projects/models/GoogleAdsRequestAnalysisGq';
import ProjectStatusKeywordRequestIcon from '../../ProjectPage/ProjectAppBar/StatusIndicator/ProjectStatusKeywordRequestIcon';
import SearchInfoForm from './Forms/SearchInfoForm/SearchInfoForm';
import VoxelTooltipLong from '../../../components/voxel/Tooltip/VoxelTooltipLong';
import ProjectStatusKeywordRequestText from '../../ProjectPage/ProjectAppBar/StatusIndicator/ProjectStatusKeywordRequestText';

export interface QuickSearchListProps {
  searchListData: GoogleAdsRequestAnalysisGq[];
  setRequestId: (id: number, projectId: number) => void;
  requestId: number;
}

const QuickSearchList: React.FC<QuickSearchListProps> = ({
  searchListData,
  setRequestId,
  requestId,
}) => {

  const [searchInfo, setSearchInfo] = useState<GoogleAdsRequestAnalysisGq>(null);

  // Fix names in old projects
  let searchName = ''
  if (searchInfo?.request?.name === 'Quick search') {
    searchName = searchInfo?.request.searchSource?.slice(0, 20)?.concat(searchInfo?.request.searchSource?.length > 20 ? '...' : '')
  } else {
    searchName = searchInfo?.request.name.slice(0, 20)?.concat(searchInfo?.request.name?.length > 20 ? '...' : '')
  }
  return (
    <div className="pl-4 h-full">
      <VoxelDialog
        title={`${searchName}`}
        open={searchInfo !== null}
        onClose={() => setSearchInfo(null)}
        minWClass='min-w-[600px]'
      >
        <VoxelDialogContent>
          <SearchInfoForm
            selectedProjectId={searchInfo?.request?.parentProjectId}
            selectedRequestId={searchInfo?.request?.id}
            selectedRequestAnalysis={searchInfo} />
        </VoxelDialogContent>
      </VoxelDialog>
      {searchListData.map((p) => {
        // Fix names in old projects
        let searchName2 = ''
        if (p?.request?.name === 'Quick search') {
          searchName2 = p?.request.searchSource?.slice(0, 20)?.concat(p?.request.searchSource?.length > 20 ? '...' : '')
        } else {
          searchName2 = p?.request.name.slice(0, 20)?.concat(p?.request.name?.length > 20 ? '...' : '')
        }

        return (
          <VoxelTooltipLong
            placement='right-start'
            message={
              <div className='flex flex-col gap-2 text-xs'>
                <div className='flex flex-row gap-2'>
                  <span className='font-medium'>Status:</span>
                  <div className='flex flex-row items-center gap-1.5'>
                    <ProjectStatusKeywordRequestText requestAnalysis={p} />
                    <ProjectStatusKeywordRequestIcon requestAnalysis={p} />
                  </div>
                </div>
                <div className='flex flex-row gap-2'>
                  <span className='font-medium'>Language:</span> {!!p?.request?.languageName?.length ? p?.request?.languageName : 'All languages'}
                </div>
                <div className='flex flex-row gap-2'>
                  <span className='font-medium'>Location:</span>  {!!p?.request?.locationName?.length ? p?.request?.locationName : 'Global'}
                </div>
              </div>
            } >
            <div
              typeof="button"
              key={p.request.id}
              onClick={() => setRequestId(p.request.id, p.request.parentProjectId)}
              className={`
              pl-1 pr-4 py-2.5 cursor-pointer border-b border-voxel-gray-100 relative group hover:bg-gray-50
              ${p.request.id === requestId ? 'bg-gray-50 group-hover:bg-gray-100' : ''}
              `}
            >
              <div
                className='absolute right-1.5 top-1/2 -translate-y-1/2 flex flex-row items-center gap-2.5'>
                <VoxelIconButton
                  onClick={(event: React.MouseEvent<any>) => { event.stopPropagation(); setSearchInfo(p); }}
                  tooltip='View search setup'
                  size='sm'
                  icon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} size='sm' />}
                  color='white'
                  onMouseUp={(event: React.MouseEvent<any>) => event.stopPropagation()}
                  onMouseDown={(event: React.MouseEvent<any>) => event.stopPropagation()}
                />
                <FontAwesomeIcon
                  icon={faChevronRight}
                  className={`${p.request.id === requestId ? '' : 'text-voxel-gray-300'}`}
                />
              </div>
              <div className='flex flex-row items-start gap-2.5'>
                <div className='pt-[0.5px]'>
                  <ProjectStatusKeywordRequestIcon requestAnalysis={p} />
                </div>
                <div className={'flex flex-col gap-1'}>
                  <VoxelText variant="table" className='!font-medium' color='dark'>
                    {SearchRequestTypes?.find((rt) => rt?.type === p?.request?.googleAdsRequestType)?.searchHistoryName}
                  </VoxelText>
                  <VoxelText variant="form-caption" >
                    {searchName2}
                  </VoxelText>
                </div>
              </div>
            </div>
          </VoxelTooltipLong>
        );
      })}
    </div >
  );
};

export default QuickSearchList;
